module.exports = __webpack_public_path__ + "static/media/icon-emtransito.5c16fc8e.svg";